export const isTimeOnly = (datetime: string) => /^\d{2}:\d{2}:\d{2}$/.test(datetime);
